import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class FeedstockService {

    constructor(protected http: HttpClient) {
    }

    baseurl = environment.apiBaseUrl;

    getFeedstock() {
        return this.http.get<any[]>(this.baseurl + 'activityprocessfeedstock/feedstocks');
    }

    addFeedstock(feedstock: any) {
        return this.http.post<any[]>(this.baseurl + 'activityprocessfeedstock/addFeedstock', feedstock);
    }

    updateFeedstock(feedstock: any) {
        return this.http.post<any[]>(this.baseurl + 'activityprocessfeedstock/updateFeedstock', feedstock);
    }

}